import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// redux
import { useDispatch, useSelector } from 'react-redux';

import v2_actionCriarDirecionamento from 'src/actions/v2/cliente/v2_actionCriarDirecionamento';
import v2_actionDeleteFlowDirect from 'src/actions/v2/cliente/v2_actionDeleteFlowDirect';
import v2_actionEditarDirecionamentoDireto from 'src/actions/v2/cliente/v2_actionEditarDirecionamentoDireto';
import v2_actionListaFluxosDiretos from 'src/actions/v2/cliente/v2_actionListaFluxosDiretos';
import Page from 'src/components/Page';
import ModalConfimacao from 'src/components/modal/ModalConfimacao';
import TableSkeleton from 'src/components/skeleton/TableSkeleton';
import { nomeProjeto } from 'src/config';
import useAuth from 'src/hooks/useAuth';
import { getListaSetoresTransferencia, getListaUsuariosTransferencia } from 'src/redux/slices/user';
import { Zap } from 'lucide-react';
import { DIRECIONAMENTOS_COMPONENT_DESIGN } from './DirecionamentosComponent.design';
import ModalDirecionamentos from './ModalDirecionamentos';
import Table from './TableDirecionamentos';

export default function DirecionamentosComponent() {
  const { t } = useTranslation('settings');
  const { user } = useAuth();
  const dispatch = useDispatch();

  const [openDialogNovoSetor, setOpenDialogNovoSetor] = useState(false);
  const [openModalConfirmacao, setOpenModalConfirmacao] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingCreate, setLoadingCreate] = useState(false);

  const [action, setAction] = useState('');
  const { listaUsuariosTransferencia, listaSetoresTransferencia } = useSelector((state) => state.user);
  ///// value fields
  const [direcionamentoId, setDirecionamentoId] = useState('');
  const [fluxos, setFluxos] = useState([]);
  const [recebe, setRecebe] = useState('');
  const [usersSelect, setUsersSelect] = useState([]);
  const [departamentSelect, setDepartamentSelect] = useState([]);
  const [sendMessage, setSendMessage] = useState(false);
  const [assignAi, setAssignAi] = useState(false);
  const [prompt, setPrompt] = useState('');

  const [dataMessage, setDataMessage] = useState({
    chatFiles: [],
    chatText: '',
    chatTypeMessage: 'text',
  });


  async function getList() {
    try {
      const response = await v2_actionListaFluxosDiretos(user.clienteId);
      setFluxos(response.data.data)
    } catch (error) {
      console.log(error);
    }

  }

  useEffect(() => {
    getList();
    dispatch(getListaUsuariosTransferencia(user.clienteId))
    dispatch(getListaSetoresTransferencia(user.clienteId))

  }, []);


  function applyFilter(tableData, filterName) {
    if (filterName) {
      tableData = tableData.filter(
        (item) =>
          item.nome.toLowerCase().indexOf(filterName.toLowerCase()) !== -1
      );
    }
    return tableData;
  }

  async function handleCriarDirecionamento() {
    try {
      setLoading(true)
      const data = {
        scope: {
          direcionaUsuarios: usersSelect,
          direcionaSetores: departamentSelect,
          recebe: recebe
        }
      }
      setLoadingCreate(true)
      await v2_actionCriarDirecionamento(user.clienteId, data);
      await getList();
      setLoading(false)
      setOpenDialogNovoSetor(false);
      setRecebe('');
      setUsersSelect([]);
      setDepartamentSelect([]);
      setLoadingCreate(false)
    } catch (error) {
      setLoading(false)
      setLoadingCreate(false)
    }
  }

  async function handleDeletarTag() {
    try {
      await v2_actionDeleteFlowDirect(direcionamentoId);
      await getList();
      setRecebe('');
      setDirecionamentoId('');
      setOpenModalConfirmacao(false);
    } catch (error) {

    }
  }

  const handleEditarTag = async () => {
    try {
      let data = {
        scope: {
          direciona_usuarios: usersSelect,
          direciona_setores: departamentSelect,
          recebe: recebe,
          sendMessage: sendMessage,
          message: dataMessage,
          assignAI: assignAi,
          prompt: prompt
        }
      }
      setLoadingCreate(true)
      await v2_actionEditarDirecionamentoDireto(direcionamentoId, data);
      await getList();
      setAction('');
      setRecebe('');
      setUsersSelect([]);
      setDepartamentSelect([]);
      setDirecionamentoId('');
      setOpenDialogNovoSetor(false);
      setLoadingCreate(false)
    } catch (error) {
      setLoadingCreate(false)
      console.log('error', error)
    }

  };


  const dataFiltered = applyFilter(fluxos, pesquisa);

  return (
    <Page title={t('targeting.pageTitle', '{{nomeProjeto}} - Direcionamentos', { nomeProjeto })}>
      <div className={DIRECIONAMENTOS_COMPONENT_DESIGN.root} style={{ fontFamily: DIRECIONAMENTOS_COMPONENT_DESIGN.fontStack }}>
        <div className={DIRECIONAMENTOS_COMPONENT_DESIGN.stickyHeader}>
          <div className={DIRECIONAMENTOS_COMPONENT_DESIGN.container}>
            <div className={DIRECIONAMENTOS_COMPONENT_DESIGN.topbar}>
              <div className={DIRECIONAMENTOS_COMPONENT_DESIGN.topbarIdentity}>
                <div className="min-w-0">
                  <h1 className={DIRECIONAMENTOS_COMPONENT_DESIGN.title}>{t('targeting.header.title', 'Direcionamentos')}</h1>
                  <p className={DIRECIONAMENTOS_COMPONENT_DESIGN.subtitle}>
                    {t('targeting.header.subtitle', 'Envie conversas para setores e pessoas automaticamente.')}
                  </p>
                </div>
              </div>
              <div className={DIRECIONAMENTOS_COMPONENT_DESIGN.topbarActions}>
                <button
                  type="button"
                  onClick={() => { setOpenDialogNovoSetor(true); setAction('Criar'); }}
                  className={DIRECIONAMENTOS_COMPONENT_DESIGN.primaryButton}
                >
                  {t('targeting.header.createButton', 'Criar direcionamento')}
                </button>
              </div>
            </div>
          </div>
        </div>

        <ModalConfimacao
          open={openModalConfirmacao}
          onClose={() => {
            setOpenModalConfirmacao(false);
          }}
          onConfirm={handleDeletarTag}
          loadingFinalizar={loading}
          mensagem={t('targeting.confirmDelete.message', 'Deseja mesmo excluir essa etiqueta?')}
        />

        {openDialogNovoSetor && (
          <ModalDirecionamentos
            users={listaUsuariosTransferencia}
            departaments={listaSetoresTransferencia}
            usersSelect={usersSelect}
            departamentSelect={departamentSelect}
            loadingCreate={loadingCreate}
            changeDepartament={(e) => {
              setDepartamentSelect(e)

            }}
            changeUser={(e) => {
              setUsersSelect(e)
            }}
            open={openDialogNovoSetor}
            action={action}
            recebe={recebe}
            changeRecebe={(e) => {
              setRecebe(e.target.value)
            }}
            onSubmit={action === "Criar" ? handleCriarDirecionamento : handleEditarTag}
            onClose={() => {
              setOpenDialogNovoSetor(false);
              setRecebe('');
              setDirecionamentoId('');
              setUsersSelect([]);
              setDepartamentSelect([]);
              setAssignAi(false);
              setPrompt('');
            }}
            sendMessage={sendMessage}
            changeSendMessage={(e) => {

              setSendMessage(e)
            }}
            data={dataMessage}
            assignAi={assignAi}
            prompt={prompt}
            changeAssignAI={(e) => {
              setAssignAi(e)
            }}
            changePrompt={(e) => {
              setPrompt(e.target.value)
            }}
            changeBlock={(e) => {
              const { name, value } = e;
              if (name === "chatTypeMessage") {
                setDataMessage({
                  ...dataMessage,
                  chatTypeMessage: value
                })
              } else if (name === "chatText") {
                setDataMessage({
                  ...dataMessage,
                  chatText: value
                })

              } else if (name === "chatFiles") {
                setDataMessage({
                  ...dataMessage,
                  chatFiles: value
                })
              }
            }}
          />
        )}

        <div className={`${DIRECIONAMENTOS_COMPONENT_DESIGN.container} pt-6 ${DIRECIONAMENTOS_COMPONENT_DESIGN.pageBody}`}>
        <div className={DIRECIONAMENTOS_COMPONENT_DESIGN.stack}>
          <div className={DIRECIONAMENTOS_COMPONENT_DESIGN.sectionHeader}>
            <div className={DIRECIONAMENTOS_COMPONENT_DESIGN.sectionHeaderMain}>
              <h2 className={DIRECIONAMENTOS_COMPONENT_DESIGN.sectionHeaderTitle}>Lista</h2>
              <p className={DIRECIONAMENTOS_COMPONENT_DESIGN.sectionHeaderSub}>
                {t('targeting.sectionSub', 'Quando o cliente envia a palavra configurada, a conversa vai para o time certo.')}
              </p>
            </div>
          </div>
          <div className={DIRECIONAMENTOS_COMPONENT_DESIGN.cardFlush}>
          {loading ? (
            <TableSkeleton />
          ) : fluxos.length === 0 ? (
            <div className={DIRECIONAMENTOS_COMPONENT_DESIGN.emptyWrap}>
              <div className={DIRECIONAMENTOS_COMPONENT_DESIGN.emptyIcon}>
                <Zap size={28} />
              </div>
              <p className={DIRECIONAMENTOS_COMPONENT_DESIGN.emptyTitle}>{t('targeting.emptyState.title', 'Nenhum direcionamento criado')}</p>
              <p className={DIRECIONAMENTOS_COMPONENT_DESIGN.emptyDesc}>
                {t('targeting.emptyState.description', 'Crie seu primeiro direcionamento para organizar o fluxo de atendimento.')}
              </p>
              <button
                type="button"
                onClick={() => { setOpenDialogNovoSetor(true); setAction('Criar'); }}
                className={`${DIRECIONAMENTOS_COMPONENT_DESIGN.link} mt-4`}
              >
                {t('targeting.emptyState.button', 'Criar direcionamento')}
              </button>
            </div>
          ) : (
            <Table
              data={dataFiltered}
              onDelete={row => {
                setDirecionamentoId(row._id);
                setOpenModalConfirmacao(true);
              }}
              onEdit={row => {
                setOpenDialogNovoSetor(true)
                setDepartamentSelect(row.direciona_setores);
                setUsersSelect(row.direciona_usuarios);
                setAction('Editar')
                setDirecionamentoId(row._id);
                setRecebe(row.recebe);
                setPrompt(row.prompt);
                setAssignAi(true);
              }}
            />
          )}
          </div>
        </div>
        </div>
      </div>
    </Page>
  );
}
